import { IShoppingBagData } from "../../types/ShoppingBag";
import { useState } from "react";
import OrderDetailsDialog from "../../dialogs/OrderDetails";
import CancelUserOrderConfirmDialog from "../../dialogs/CancelUserOrderConfirmDialog";
import { Box } from "@mui/system";
import { Button, Card, CardActions, CardContent, Divider, Typography } from "@mui/material";
import { Colors } from "../../helpers/Consts";
import { getDataExtensoSimples } from "../../helpers/Utils";
import OrderItemDetails from "./orderItemDetails";
import IfWithdrawShowAddress from "../../dialogs/OrderDetails/ifWithdrawShowAddress";

type Props = {
  order: IShoppingBagData;
};

/**
 * Exibe os detalhes de um pedido, APENAS para pedidos do tipo ENTREGA ou RETIRADA.
 * Para pedidos do tipo MESA, veja TableOrderDetailsCard.
 *
 * @param order
 * @constructor
 */
function SingleOrderCard({ order }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(!open);
  };
  const handleCancelOrder = () => {
    setOpenConfirmDialog(!openConfirmDialog);
  };

  const dateToString = (date: string | undefined) => {
    if (!date) return "";
    return new Date(date).toLocaleString("pt-Br");
  };
  return (
    <>
      <OrderDetailsDialog order={order} open={open} handleClose={handleClose} />
      <CancelUserOrderConfirmDialog
        open={openConfirmDialog}
        order={order}
        handleCloseDialog={handleCancelOrder}
      />
      <Box
        sx={{
          marginBottom: 2,
        }}
      >
        <Typography
          sx={{ fontSize: "0.7rem" }}
          fontWeight="700"
          color={Colors.baseTextColor}
        >
          {getDataExtensoSimples(
            dateToString(order.created_at),
            //new Date(order.created_at).toLocaleDateString("pt-Br")
          )}
        </Typography>
        <Card variant="outlined">
          <CardContent>
            <Box sx={{ display: "flex" }}>
              <Typography
                fontSize="0.7rem"
                color={Colors.baseTextColor}
                fontWeight="300"
              >
                Pedido #
              </Typography>
              <Typography
                fontSize="0.7rem"
                color={Colors.grayTextColorDarkestDark}
                fontWeight="700"
              >
                {order.id}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Typography fontSize="0.6rem" color={Colors.grayTextColorDarkest}>
                {
                  dateToString(order.created_at)
                  //new Date(order.created_at).toLocaleString("pt-Br")
                }
              </Typography>
            </Box>
            <Box sx={{ display: "flex" }}>
              <Typography
                fontSize="0.6rem"
                color={order.status !== 13 ? Colors.orangePrimary : "red"}
                fontWeight="700"
              >
                {order.status_description === "Criado"
                  ? "Sacola em Aberto"
                  : order.status_description}
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Typography
                fontSize="0.6rem"
                color={order.status !== 13 ? Colors.orangePrimary : "red"}
              >
                {order.status === 13
                  ? dateToString(order.cancelled_at)
                  //new Date(order.cancelled_at).toLocaleString("pt-Br")
                  : dateToString(order.updated_at)
                  //new Date(order.updated_at).toLocaleString("pt-Br")
                }
              </Typography>
            </Box>
            <Divider sx={{ padding: "5px" }} />
            <Box paddingTop={"15px"} display={"flex"}>
              <Box
                component="img"
                sx={{ borderRadius: "50%", height: "50px" }}
                src={order.placeInfo.logo_image}
                alt="alt"
              />
              <Box p={1} marginLeft={"10px"}>
                <Typography
                  fontSize="0.8rem"
                  fontWeight={"700"}
                  color={Colors.grayTextColorDarkestDark}
                >
                  {order.placeInfo.name}
                </Typography>
                <Typography fontSize="0.6rem" color={Colors.baseTextColor}>
                  {order.placeInfo.short_description}
                </Typography>
              </Box>
            </Box>
            <IfWithdrawShowAddress order={order} />
            <Divider sx={{ padding: "5px" }} />
            <Box padding={"10px 0px"}>
              {order.items.map((item) => (
                <Box
                  sx={{
                    marginBottom: "6px",
                  }}
                  key={item.id}
                >
                  <OrderItemDetails singleItem={item} />
                </Box>
              ))}
            </Box>
          </CardContent>
          <CardActions>
            {order.status !== 1 && (
              <Box sx={{ width: "100%" }}>
                <Button
                  size="small"
                  sx={{
                    width: "50%",
                    color: "red",
                    textTransform: "none",
                  }}
                  disabled={
                    // status 1 = Criado (sacola)
                    // status 12 = Aguardando confirmação
                    !(order.status === 1 || order.status === 12)
                  }
                  onClick={() => {
                    handleCancelOrder();
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  size="small"
                  sx={{
                    width: "50%",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Detalhes
                </Button>
              </Box>
            )}
          </CardActions>
        </Card>
      </Box>
    </>
  );
}

export default SingleOrderCard;